const config = {
  MUNROE_BUCKET_NAME: process.env.REACT_APP_MUNROE_BUCKET,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
}

export default config
